var React = require('react');

function VideoControlsRewindInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.3717 5.00977V18.9812L0.5 11.9955L11.3717 5.00977Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M22.4999 5.00977V18.9812L11.6282 11.9955L22.4999 5.00977Z","fill":"currentColor","key":1})]);
}

VideoControlsRewindInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = VideoControlsRewindInline;

VideoControlsRewindInline.default = VideoControlsRewindInline;
